import React from 'react'

const EchoesFeatures = () =>
  <div className="page feature">
    <h1>Echoes</h1>
  </div>

export default EchoesFeatures
